import moment from 'moment';
import * as Yup from 'yup';

import { Input } from '@treams/treams-ui';

import FormErrorMessage from 'packages/kakapo-ui-kit/components/forms/errors/FormErrorMessage';
import { ISheetEditorEvents } from 'packages/kakapo-ui-settings-application/pages/bulk-employee-edit/types/sheet';

const BulkDateField = ({
	value,
	events,
	validationSchema,
}: {
	value: string | undefined;
	events: ISheetEditorEvents;
	validationSchema?: Yup.StringSchema;
}) => {
	const invalid = validationSchema ? !validationSchema.isValidSync(value) : false;
	const date = value?.length ? moment(value).toDate() : undefined;

	return (
		<>
			<Input.DatePicker
				autoFocus
				value={date}
				onChange={(date) => {
					if (date) {
						events.onChange(moment(date).add(12, 'hours').toISOString());
					} else {
						events.onChange(undefined);
					}
				}}
			/>
			{invalid && <FormErrorMessage error={new Error('Field invalid.')} />}
		</>
	);
};

export default BulkDateField;
